module.exports = require('./_core');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_path.js
// module id = 871
// module chunks = 10